import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AsyncSelect from "react-select/async";

import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

import './Style.css';

class ModalDemerito extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            operadorSelecionado: null,
            empreendimentoSelecionado: null,
            motivosSelecionados: [],
            cityId: null,
            form: {
                id: null,
                operador_id: '',
                building_id: '',
                motivos: [],
                comentario: null,
            },
            loadingData: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            this.initializeModal();
        }
    }

    initializeModal = async () => {
        const {
            demeritId
        } = this.props;

        if (!demeritId) {
            this.resetForm();
            return;
        }

        await this.loadDemerit(demeritId);
    };

    loadDemerit = async (id) => {
        this.setState({
            loadingData: true,
        });

        try {
            const response = await axios.get(
                `/visualizar-avaliacao/${id}`
            );

            const demerit = response.data;

            let empreendimento = null;
            if (demerit.building) {
                empreendimento = {
                    id: demerit.building.id,
                    text: `${demerit.building.id} - ${demerit.building.name}`,
                };
            }

            const motivosMap = new Map();

            (demerit.criteria || []).forEach((criterion) => {

                const weight = criterion.evaluation_weigth;

                if (!weight) {
                    return;
                }

                if (!motivosMap.has(weight.id)) {
                    motivosMap.set(weight.id, {
                        id: weight.id,
                        text: `${weight.reason} / ${weight.criterion}`,
                        evaluation_weight_id: criterion.evaluation_weigth_id,
                        evaluation_rule_id: criterion.evaluation_rule_id,
                        conditional_id: criterion.condicional_id,
                    });
                }
            });

            const motivos = Array.from(motivosMap.values());

            this.setState({
                empreendimentoSelecionado: empreendimento,
                motivosSelecionados: motivos,
                form: {
                    id: demerit.id || null,
                    operador_id: demerit.operador_id || null,
                    building_id: demerit.building_id || '',
                    motivos,
                    comentario: demerit.comentario || '',
                },
                loadingData: false,
                cityId: demerit.city_id,
            });

        } catch (error) {
            console.error('Erro ao carregar demérito:', error);

            this.setState({
                loadingData: false,
            });
        }
    };

    resetForm = () => {
        this.setState({
            operadorSelecionado: null,
            empreendimentoSelecionado: null,
            motivosSelecionados: [],
            form: {
                id: null,
                operador_id: '',
                building_id: '',
                motivos: [],
                comentario: '',
            },
            loadingData: false,
        });
    };

    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState({
            form: {
                ...this.state.form,
                [name]: value,
            },
        });
    };

    searchUsers = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                '/autocomplete-users',
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar operadores:', error);
            return [];
        }
    };

    searchBuildings = async (inputValue) => {
        const {
            demeritId
        } = this.props;

        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const cityId = !demeritId ? this.props.cityPeriod?.city_id : this.state.cityId;
            if (!cityId) {
                return [];
            }

            const response = await axios.get(
                `/autocomplete-with-ids/${cityId}`,
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar empreendimentos:', error);
            return [];
        }
    };

    searchMotivos = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                `/autocomplete-motivos`,
                {
                    params: {
                        search: inputValue,
                        tipo: 'Demérito',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar motivos:', error);
            return [];
        }
    };

    handleOperadorChange = (selectedOption) => {
        this.setState({
            operadorSelecionado: selectedOption,

            form: {
                ...this.state.form,
                operador_id: selectedOption ? selectedOption.id : '',
            },
        });
    };

    handleEmpreendimentoChange = (selectedOption) => {
        this.setState({
            empreendimentoSelecionado: selectedOption,

            form: {
                ...this.state.form,
                building_id: selectedOption ? selectedOption.id : '',
            },
        });
    };

    handleMotivosChange = (selectedOptions) => {
        const motivos = selectedOptions || [];

        this.setState({
            motivosSelecionados: motivos,

            form: {
                ...this.state.form,
                motivos,
            },
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const {
            form,
        } = this.state;

        const {
            demeritId
        } = this.props;

        if (!demeritId && !form.operador_id) {
            alert('Selecione um operador antes de continuar!');
            return;
        }

        if (!form.building_id) {
            alert('Selecione um empreendimento antes de continuar!');
            return;
        }

        if (!form.motivos || form.motivos.length === 0) {
            alert('Selecione ao menos um motivo antes de continuar!');
            return;
        }

        const data = {
            ...form,
            id: form.id || null,
        };

        await this.props.onSubmit(data);
    };

    handleClose = () => {
        if (this.props.loading || this.state.loadingData) {
            return;
        }

        this.resetForm();

        this.props.onClose();
    };

    render() {

        const {
            open,
            loading,
        } = this.props;

        const {
            form,
            operadorSelecionado,
            empreendimentoSelecionado,
            loadingData,
        } = this.state;

        const isEdit = !!form.id;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={this.handleClose}
                    dialogClassName="modal-demerito"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isEdit ? 'Editar Demérito' : 'Novo Demérito'}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {loadingData ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>{' '}
                                Carregando...
                            </div>
                        ) : (
                            <form
                                className="form-modal"
                                onSubmit={this.handleSubmit}
                            >
                                <div className="formulario">
                                    {!isEdit && (
                                        <div className="form-group">
                                            <label>Operador</label>

                                            <AsyncSelect
                                                value={operadorSelecionado}
                                                loadOptions={this.searchUsers}
                                                isClearable
                                                getOptionLabel={(option) => option.text}
                                                getOptionValue={(option) => String(option.id)}
                                                onChange={this.handleOperadorChange}
                                                className="autocomplete"
                                                styles={asyncSelectCustomStyles}
                                                placeholder="Buscar"
                                                components={reactSelectIcons}
                                                noOptionsMessage={() => "Digite para buscar..."}
                                                loadingMessage={() => 'Carregando...'}
                                                isDisabled={loading}
                                            />
                                        </div>
                                    )}

                                    <div className="form-group">
                                        <label>Empreendimento</label>

                                        <AsyncSelect
                                            value={empreendimentoSelecionado}
                                            loadOptions={this.searchBuildings}
                                            isClearable
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={this.handleEmpreendimentoChange}
                                            styles={asyncSelectCustomStyles}
                                            className="autocomplete"
                                            placeholder="Buscar"
                                            components={reactSelectIcons}
                                            noOptionsMessage={() => "Digite para buscar..."}
                                            loadingMessage={() => 'Carregando...'}
                                            isDisabled={loading || loadingData}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Motivo / Critério</label>

                                        <AsyncSelect
                                            isMulti
                                            closeMenuOnSelect={false}
                                            value={form.motivos}
                                            loadOptions={this.searchMotivos}
                                            isClearable
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={this.handleMotivosChange}
                                            styles={asyncSelectCustomStyles}
                                            placeholder="Selecione"
                                            components={reactSelectIcons}
                                            noOptionsMessage={() => "Digite para buscar..."}
                                            loadingMessage={() => 'Carregando...'}
                                            className="autocomplete"
                                            isDisabled={loading || loadingData}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Comentário</label>

                                        <textarea
                                            className=""
                                            placeholder="Digite"
                                            rows="1"
                                            cols="3"
                                            name="comentario"
                                            value={form.comentario || ''}
                                            onChange={this.handleInputChange}
                                            disabled={loading || loadingData}
                                        />
                                    </div>

                                    <div className="form-buttons">
                                        <button
                                            type="submit"
                                            className="btn btn-success btn-round background-brain"
                                            disabled={loading || loadingData}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin"></i>{' '}
                                                    Processando...
                                                </>
                                            ) : (
                                                isEdit ? 'Atualizar' : 'Salvar'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalDemerito;